import { render, staticRenderFns } from "./experienceAI.vue?vue&type=template&id=4a50cbf8&scoped=true&"
import script from "./experienceAI.vue?vue&type=script&lang=js&"
export * from "./experienceAI.vue?vue&type=script&lang=js&"
import style0 from "./experienceAI.vue?vue&type=style&index=0&id=4a50cbf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a50cbf8",
  null
  
)

export default component.exports